import { GetterTree } from "vuex";
import { RootState } from "@/store/types";

import { IntegrationState } from "../types";

const getters: GetterTree<IntegrationState, RootState> = {
  getPublicKey(state) {
    return state.publicKey;
  },
  getSecretKey(state) {
    return state.secretKey;
  },
};

export default getters;
